export * from "./pricing.component";